// ------------------------------------
// Configurações Gerais
// ------------------------------------

// Informações do site
const $infosBase = $('#infos-base');
const urlBase = $infosBase.data('base-url'); // URL base do site
const pagBase = $infosBase.data('base-pag'); // Página atual

// ------------------------------------
// Habilita os tooltips
// ------------------------------------
initTooltips();
function initTooltips() {
  $('[data-toggle="tooltip"]').tooltip({ html: true });
}

// ------------------------------------
// Custom File Input
// ------------------------------------
$(function () {
  initBsCustomFileInput();
});
function initBsCustomFileInput() {
  bsCustomFileInput.init();
}

// ------------------------------------
// Alerta os usuários antes da página ser redirecionada
// ------------------------------------
function windowAlertReload(ev) {
  ev.preventDefault();
  ev.returnValue = '';
}
if ($('.tab-alert').length > 0) {
  window.addEventListener('beforeunload', windowAlertReload);
}

// ------------------------------------
// Atualiza os botões toggle radio
// ------------------------------------
$('.btn-group-toggle').each(function () {
  const $el = $(this);
  const $opts = $el.find('.btn');
  $opts.removeClass('active');
  $el.find('input:checked').parent('.btn').addClass('active');
});

// ------------------------------------
// Botões fixos nos formulários
// ------------------------------------
$(function () {
  if ($('.form-btns-fixed').length > 0) {
    const $window = $(window);
    const scrollAnimationDebounce = 50;
    const $el = $('.form-btns-fixed-anchor');
    $window.on(
      'scroll',
      debounce(function () {
        checkVisibility();
      }, scrollAnimationDebounce),
    );
    // Verifica se o elemento está visível na tela
    function checkVisibility() {
      if (isElVisible($el)) {
        $('.form-btns-fixed').removeClass('active');
        if (isMedia('lg')) {
          $('.form-btns-fixed > div').css('padding-right', 0);
        }
      } else {
        $('.form-btns-fixed').addClass('active');
        if (isMedia('lg')) {
          let pr =
            $(window).width() -
            ($('.form-btns-fixed-anchor').offset().left + $('.form-btns-fixed-anchor').width()) -
            20;
          $('.form-btns-fixed > div').css('padding-right', pr);
        }
      }
    }
    checkVisibility();
  }
});

// ------------------------------------
// Imagem placeholder
// ------------------------------------
const imgEmpty = urlBase + 'app/assets/dist/img/thumb_img.png';

// ------------------------------------
// Imagem placeholder
// ------------------------------------
if ($(window).width() > 780 && $(window).width() <= 1280) {
  $('body.sidebar-mini').addClass('sidebar-collapse');
}

// Corrige o problema quando fecha mais de um modal e o scroll buga
$('.modal').on('hidden.bs.modal', function (e) {
  if ($('.modal:visible').length) {
    $('body').addClass('modal-open');
  }
});

// Corrige bug da tecla Enter nos campos de buscar produtos nas categorias e coleções
$(function () {
  $(document).on('keydown', '#campo-select-produtos', function (event) {
    return event.key != 'Enter';
  });
});

// ------------------------------------
// Opções de SEO
// ------------------------------------

(function () {
  'use strict';

  if ($('.seo-preview').length) {
    // Variáveis
    const acaoForm = $('.seo-preview').closest('.form-admin').find('input[name="acao"]').val();
    const $pvUrl = $('.seo-preview-url-pag');
    const $pvTit = $('.seo-preview-title');
    const $pvDesc = $('.seo-preview-description');
    const $inputUrl = $('#seo_url');
    const $inputTit = $('#seo_title');
    const $inputDesc = $('#seo_description');
    const $inputTitOriginal = $($inputTit.data('original'));

    // Ao alterar o título original da página (Somente no cadastro)
    if ($inputTitOriginal.length) {
      $inputTitOriginal.on('change', function (ev) {
        if (acaoForm == 'insert' && $inputTit.val() == '') {
          $inputTit.val($inputTitOriginal.val()).trigger('change');
        }
      });
    }

    // Ao alterar o título
    $inputTit.on('change input', function (ev) {
      $pvTit.text($inputTit.val());
      /* if (acaoForm == 'insert') {
        $inputUrl.val(slugify($inputTit.val())).trigger('change');
      } */
    });

    // Ao alterar a descrição
    $inputDesc.on('change input', function (ev) {
      $pvDesc.text($inputDesc.val());
    });

    // Ao alterar a url
    $inputUrl.on('change input', function (ev) {
      $pvUrl.text($inputUrl.val());
    });
  }
})();
